<template>
  <div id="cooperate">
    <div class="inner">
      <div class="top">
        <div class="top-l">
          <img src="@/assets/keeta-footer-1.png" alt="" class="top-l-img-t" />
          <div class="top-l-text" v-if="country === 'hongkong'">
            {{ $t("home_cooperate_follow_us") }}
          </div>
          <img
            v-if="country === 'hongkong'"
            src="@/assets/Keeta2/container-105793@2x.png"
            alt=""
            class="top-l-img-b"
          />
        </div>
        <div class="top-r">
          <div>
            <div>{{ $t("home_cooperate_contact_us") }}</div>
            <div class="top_desc" v-for="(item, idx) in topList" :key="idx">
              <div
                class="top_content_title"
                v-if="!(country === 'hongkong' && idx === 0)"
              >
                {{ $t(item.title) }}
              </div>
              <div
                class="top_content_desc"
                v-if="!(country === 'hongkong' && idx === 0)"
              >
                {{ item.desc }}
              </div>
            </div>
          </div>
          <div>
            <div class="top_more">
              {{ $t("home_cooperate_more_info") }}
              <div class="top_more_list">
                <p>
                  <a :href="privacyPolicyLink">{{
                    $t("home_cooperate_terms")
                  }}</a>
                </p>
                <p>
                  <a :href="privacyPolicyLinks">{{
                    $t("home_cooperate_privacy")
                  }}</a>
                </p>
                <p v-if="country !== 'hongkong'">
                  <a :href="privacyPolicyLinkv">{{
                    $t("home_cooperate_vulnerability")
                  }}</a>
                </p>
              </div>
            </div>
            <div class="top_more" v-if="country !== 'hongkong'">
              {{ $t("home_cooperate_company") }}
              <div class="top_more_list">
                <p>
                  <a :href="privacyPolicyLinkc">{{
                    $t("home_cooperate_careers")
                  }}</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getCountryByDomain } from "@/common/config";
export default {
  name: "CooperateView",
  data() {
    return {
      topList: [
        {
          title: "home_cooperate_address",
          desc: "Rm 519, 52 Grosvenor Gardens, London, Greater London SW1W 0AU",
        },
        { title: "home_cooperate_market", desc: "powerbankmkt@keetainc.com" },
        {
          title: "home_cooperate_service",
          desc: "powerbankservice@keetainc.com",
        },
      ],
    };
  },
  methods: {},
  computed: {
    country() {
      return getCountryByDomain(window.location.hostname);
    },
    privacyPolicyLink() {
      if (this.country === "hongkong") {
        return "https://page.meituan.net/html/1739180527708_4d1427/index.html"; // 香港隐私政策链接
      }
      return "https://enter-h5-uk.powerbank.mykeeta.com/html/1749815699708_d136d4/index.html";
    },
    privacyPolicyLinks() {
      if (this.country === "hongkong") {
        return "https://page.meituan.net/html/1739180562168_ec957f/index.html"; // 香港条款链接
      }
      return "https://enter-h5-uk.powerbank.mykeeta.com/html/1749815640227_6b5f00/index.html";
    },
    privacyPolicyLinkv() {
      return "https://enter-h5-uk.powerbank.mykeeta.com/html/1750245395839_72bba5/index.html";
    },
    privacyPolicyLinkc() {
      if (this.country === "uk") {
        return "https://www.linkedin.com/jobs/view/4295311619";
      } else if (this.country === "hongkong") {
        return "https://www.linkedin.com/jobs/view/4301161828";
      }
      // 默认返回英国链接
      return "https://www.linkedin.com/jobs/view/4295311619";
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/_variables.scss";
#cooperate {
  min-width: $min-width;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0 50px 0;
  background-color: #111111;
  .inner {
    width: 1200px;
  }

  .top {
    display: flex;
    font-family: $content-font;
    .top-l {
      text-align: center;
      .top-l-text {
        color: #ffffff;
        font-size: 0.42rem;
        line-height: 26px;
      }
      .top-l-img-t {
        width: 80px;
      }
      .top-l-img-b {
        margin-top: 15px;
        width: 75px;
        // height: 25px;
      }
    }
    .top-r {
      width: 100%;
      display: flex;
      justify-content: space-between;
      color: white;
      font-size: $font-size-base;
      font-weight: 700;
      margin-left: 106px;
      .top_desc {
        margin-top: 40px;
        .top_content_title {
          font-size: $font-size-mini;
          font-weight: 700;
          line-height: 32px;
        }
        .top_content_desc {
          font-size: $font-size-mini;
          font-weight: 400;
          line-height: 32px;
          color: #ffdd00;
        }
      }
      .top_desc:nth-child(2) {
        margin-top: 15px;
      }
      .top_more {
        .top_more_list {
          font-size: $font-size-mini;
          font-weight: 400;
          line-height: 40px;
          margin-top: 15px;
          a {
            color: white;
            text-decoration: none;
          }
        }
      }
      .top_more:nth-child(2) {
        margin-top: 40px;
      }
    }
  }
}
</style>